import React from 'react';
import { Alert, Box, Divider, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

export default function BankCsvImportReport({ importResult }) {
    if (!importResult) {
        return null;
    }

    return (
        <Box>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Import-Report
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Kategorie</TableCell>
                        <TableCell align="right">Anzahl</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Importiert</TableCell>
                        <TableCell align="right">{importResult.imported || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Uebersprungen</TableCell>
                        <TableCell align="right">{importResult.skipped || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Fehler</TableCell>
                        <TableCell align="right">{importResult.errors || 0}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {Array.isArray(importResult.warnings) && importResult.warnings.length > 0 && (
                <Box sx={{ mt: 2 }}>
                    {importResult.warnings.map((warning, index) => (
                        <Alert key={`bank-warning-${index}`} severity="warning" sx={{ mb: 1 }}>
                            {warning}
                        </Alert>
                    ))}
                </Box>
            )}
            {Array.isArray(importResult.errorMessages) && importResult.errorMessages.length > 0 && (
                <Box sx={{ mt: 2 }}>
                    {importResult.errorMessages.map((message, index) => (
                        <Alert key={`bank-error-${index}`} severity="error" sx={{ mb: 1 }}>
                            {message}
                        </Alert>
                    ))}
                </Box>
            )}
        </Box>
    );
}
